import { ReactNode } from "react";

export const MODAL_SHOW = "MODAL_SHOW";

export interface Message {
  title?: string;
  titlePosition?: "left" | "center" | "right";
  width?: number;
  height?: number;
  visible?: boolean;
  children?: ReactNode;
}

export interface MessageAction {
  type: typeof MODAL_SHOW;
  payload: Message;
}

export function modalShow(modal: Message): ModalActionTypes {
  return {
    type: MODAL_SHOW,
    payload: modal
  };
}

export type ModalActionTypes = MessageAction;
try {
    // @ts-ignore
    modalShow.displayName = "modalShow";
    // @ts-ignore
    modalShow.__docgenInfo = { "description": "", "displayName": "modalShow", "props": { "title": { "defaultValue": null, "description": "", "name": "title", "required": false, "type": { "name": "string" } }, "titlePosition": { "defaultValue": null, "description": "", "name": "titlePosition", "required": false, "type": { "name": "\"center\" | \"left\" | \"right\"" } }, "width": { "defaultValue": null, "description": "", "name": "width", "required": false, "type": { "name": "number" } }, "height": { "defaultValue": null, "description": "", "name": "height", "required": false, "type": { "name": "number" } }, "visible": { "defaultValue": null, "description": "", "name": "visible", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Modal/actions/modal.actions.ts#modalShow"] = { docgenInfo: modalShow.__docgenInfo, name: "modalShow", path: "src/shared/containers/Modal/actions/modal.actions.ts#modalShow" };
}
catch (__react_docgen_typescript_loader_error) { }